const MOCK_MODULES = [
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-15",
    workOrder: "12WO010035",
    itemNumber: "P42-PB2-FR-107",
    batchNumber: "CDLRZ00205103&04002",
    sqft: 810,
    currentStation: "Station 8",
    jobsRedone: 2,
    timeInStation: "2h 45m",
    completionRate: 38,
    estCompletionDate: "2026-04-21",
    timeOnLine: "4d 0h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012001",
        status: "Completed",
        workers: "Jesus Aguilar Parra, Ramon Armenta",
        lastUpdated: "2026-04-15 08:30",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012002",
        status: "Completed",
        workers: "Keith Alves",
        lastUpdated: "2026-04-15 11:15",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012003",
        status: "Completed",
        workers: "Edgar Atienzo, Jacob Bayardo",
        lastUpdated: "2026-04-15 14:20",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012004",
        status: "Completed",
        workers: "Salvador Belmudes",
        lastUpdated: "2026-04-16 09:45",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012005",
        status: "Completed",
        workers: "Brandon Brock, Timothy Caine",
        lastUpdated: "2026-04-16 13:30",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012006",
        status: "Completed",
        workers: "Isaac Campillo",
        lastUpdated: "2026-04-17 10:15",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012007",
        status: "Completed",
        workers: "Jose Casillas, Kevin Castillo",
        lastUpdated: "2026-04-17 15:40",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012008",
        status: "In Progress",
        workers: "Joshua Dawson, David Derichsweiler",
        lastUpdated: "2026-04-18 10:22",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012009",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012010",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 6",
    onlineDate: "2026-04-16",
    workOrder: "12WO001003",
    itemNumber: "P42-PB2-FR-207",
    batchNumber: "CDLRZ00205203&04002",
    sqft: 552,
    currentStation: "Station 12",
    jobsRedone: 4,
    timeInStation: "3h 22m",
    completionRate: 62,
    estCompletionDate: "2026-04-20",
    timeOnLine: "6d 0h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012011",
        status: "Completed",
        workers: "Antonio Edwards, Josef Eid",
        lastUpdated: "2026-04-16 07:45",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012012",
        status: "Completed",
        workers: "Nathan Esper",
        lastUpdated: "2026-04-16 10:30",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012013",
        status: "Completed",
        workers: "Jesus Felix, Richard Fernandez",
        lastUpdated: "2026-04-16 13:15",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012014",
        status: "Completed",
        workers: "Anthony Flores",
        lastUpdated: "2026-04-17 08:20",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012015",
        status: "Completed",
        workers: "Shane Fry, Christian Garay",
        lastUpdated: "2026-04-17 12:45",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012016",
        status: "Completed",
        workers: "Alexis Garcia",
        lastUpdated: "2026-04-18 09:30",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012017",
        status: "Completed",
        workers: "Anthony Garcia, Myriah Gass",
        lastUpdated: "2026-04-18 14:15",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012018",
        status: "Completed",
        workers: "Juan Godinez",
        lastUpdated: "2026-04-19 10:40",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012019",
        status: "Completed",
        workers: "Gerald Gonzalez, Luis Gonzalez",
        lastUpdated: "2026-04-19 15:20",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012020",
        status: "Completed",
        workers: "Jeremy Goritski",
        lastUpdated: "2026-04-20 09:15",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012021",
        status: "Completed",
        workers: "Jonathan Gressel, Nestor Gutierrez",
        lastUpdated: "2026-04-20 13:50",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012022",
        status: "In Progress",
        workers: "Zachary Hall, Adrian Hernandez",
        lastUpdated: "2026-04-21 11:35",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012023",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Bulkhead/Drop Ceiling Install",
        jobId: "JOB000012024",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 326 - PROTO",
    onlineDate: "2026-04-17",
    workOrder: "12WO001005",
    itemNumber: "P42-PB2-FRC-307",
    batchNumber: "CDLRZ00205303&04002",
    sqft: 507,
    currentStation: "Station 5",
    jobsRedone: 1,
    timeInStation: "2h 05m",
    completionRate: 23,
    estCompletionDate: "2026-04-24",
    timeOnLine: "2d 12h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012025",
        status: "Completed",
        workers: "Alfredo Hernandez, Dan Hernandez",
        lastUpdated: "2026-04-17 08:15",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012026",
        status: "Completed",
        workers: "Juan Ibarra",
        lastUpdated: "2026-04-17 11:45",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012027",
        status: "Completed",
        workers: "Avery Jeffery, Matthew Johnson",
        lastUpdated: "2026-04-17 15:30",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012028",
        status: "Completed",
        workers: "Antwone LeGall",
        lastUpdated: "2026-04-18 09:20",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012029",
        status: "In Progress",
        workers: "Pablo Leon, Jorge Leon Arvizu",
        lastUpdated: "2026-04-19 10:45",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012030",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012031",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-17",
    workOrder: "12WO001002",
    itemNumber: "P42-PB1-MR-108",
    batchNumber: "CDLRZ32603117E002",
    sqft: 810,
    currentStation: "Station 15",
    jobsRedone: 3,
    timeInStation: "2h 15m",
    completionRate: 73,
    estCompletionDate: "2026-04-19",
    timeOnLine: "7d 12h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012032",
        status: "Completed",
        workers: "Jose Lopez, Ivan Lucero",
        lastUpdated: "2026-04-17 07:30",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012033",
        status: "Completed",
        workers: "Jesse Marquez",
        lastUpdated: "2026-04-17 10:15",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012034",
        status: "Completed",
        workers: "Rosalio Marquez, Gene Marsh",
        lastUpdated: "2026-04-17 14:40",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012035",
        status: "Completed",
        workers: "Liliana Martinez",
        lastUpdated: "2026-04-18 08:25",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012036",
        status: "Completed",
        workers: "Ramon Martinez, Margarito Mauricio",
        lastUpdated: "2026-04-18 12:50",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012037",
        status: "Completed",
        workers: "Brian McQuay",
        lastUpdated: "2026-04-19 09:10",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012038",
        status: "Completed",
        workers: "Manuel Medina, Oscar Mendoza",
        lastUpdated: "2026-04-19 14:35",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012039",
        status: "Completed",
        workers: "Nicholas Mojica",
        lastUpdated: "2026-04-20 10:15",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012040",
        status: "Completed",
        workers: "Jose Morales, Isaac Morrison",
        lastUpdated: "2026-04-20 15:45",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012041",
        status: "Completed",
        workers: "Scott Morrison",
        lastUpdated: "2026-04-21 09:30",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012042",
        status: "Completed",
        workers: "Dylan Munoz, Oscar Murillo Garcia",
        lastUpdated: "2026-04-21 13:20",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012043",
        status: "Completed",
        workers: "Travis Nez",
        lastUpdated: "2026-04-22 10:55",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012044",
        status: "Completed",
        workers: "Jesus Ochoa-Larios, Steven Ontiveros",
        lastUpdated: "2026-04-22 15:10",
      },
      {
        jobName: "Bulkhead/Drop Ceiling Install",
        jobId: "JOB000012045",
        status: "Completed",
        workers: "Seth Ornelas",
        lastUpdated: "2026-04-23 09:45",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012046",
        status: "In Progress",
        workers: "Efren Ortiz, Martin Ortiz",
        lastUpdated: "2026-04-23 14:28",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012047",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012048",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-17",
    workOrder: "12WO001006",
    itemNumber: "P42-PB1-MR-208",
    batchNumber: "CDLRZ00205103&04006",
    sqft: 552,
    currentStation: "Station 3",
    jobsRedone: 0,
    timeInStation: "3h 51m",
    completionRate: 12,
    estCompletionDate: "2026-04-25",
    timeOnLine: "1d 12h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012049",
        status: "Completed",
        workers: "Daniel Osuna, Charles Parker",
        lastUpdated: "2026-04-17 08:45",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012050",
        status: "Completed",
        workers: "Thomas Perez",
        lastUpdated: "2026-04-17 12:20",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012051",
        status: "In Progress",
        workers: "Dominic Perreault, Alexander Perry",
        lastUpdated: "2026-04-18 11:15",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012052",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 6",
    onlineDate: "2026-04-16",
    workOrder: "12WO001007",
    itemNumber: "P42-PB1-MRC-308",
    batchNumber: "CDLRZ00205203&04006",
    sqft: 507,
    currentStation: "Station 18",
    jobsRedone: 4,
    timeInStation: "2h 12m",
    completionRate: 88,
    estCompletionDate: "2026-04-17",
    timeOnLine: "9d 0h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012053",
        status: "Completed",
        workers: "James Phillips, Leighton Pittmann",
        lastUpdated: "2026-04-16 07:20",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012054",
        status: "Completed",
        workers: "Marc Portenier",
        lastUpdated: "2026-04-16 10:45",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012055",
        status: "Completed",
        workers: "Joel Reyes Rios, Rowan Ripley",
        lastUpdated: "2026-04-16 14:30",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012056",
        status: "Completed",
        workers: "Ubaldo Rodriguez",
        lastUpdated: "2026-04-17 08:15",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012057",
        status: "Completed",
        workers: "Adrian Roque, Carmen Roque",
        lastUpdated: "2026-04-17 12:40",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012058",
        status: "Completed",
        workers: "Jess Roth",
        lastUpdated: "2026-04-18 09:25",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012059",
        status: "Completed",
        workers: "Alexander Ruelas, Maxwell Ruiz",
        lastUpdated: "2026-04-18 14:50",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012060",
        status: "Completed",
        workers: "Chris Sanchez",
        lastUpdated: "2026-04-19 10:30",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012061",
        status: "Completed",
        workers: "Joseph Scerbo, Nicholas Schembri",
        lastUpdated: "2026-04-19 15:15",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012062",
        status: "Completed",
        workers: "Clint Shullaw",
        lastUpdated: "2026-04-20 09:40",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012063",
        status: "Completed",
        workers: "Chris Skaggs, Carter Snell",
        lastUpdated: "2026-04-20 14:25",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012064",
        status: "Completed",
        workers: "Isaac Soliz",
        lastUpdated: "2026-04-21 10:50",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012065",
        status: "Completed",
        workers: "Bunna Som, Skyler Stoker",
        lastUpdated: "2026-04-21 15:35",
      },
      {
        jobName: "Bulkhead/Drop Ceiling Install",
        jobId: "JOB000012066",
        status: "Completed",
        workers: "Everardo Suarez",
        lastUpdated: "2026-04-22 09:20",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012067",
        status: "Completed",
        workers: "Michael Taylor, Dominick Teller",
        lastUpdated: "2026-04-22 14:15",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012068",
        status: "Completed",
        workers: "Kylan Thurston",
        lastUpdated: "2026-04-23 10:45",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012069",
        status: "Completed",
        workers: "Dat Tran, Cristofer Valencia",
        lastUpdated: "2026-04-23 15:30",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012070",
        status: "In Progress",
        workers: "Gabriel Valles, Keenen Vanley",
        lastUpdated: "2026-04-24 11:18",
      },
      {
        jobName: "Gypsum and Install",
        jobId: "JOB000012071",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012072",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-15",
    workOrder: "12WO001008",
    itemNumber: "P42-PL1-TG.2-109",
    batchNumber: "CDLRZ00205303&04006",
    sqft: 810,
    currentStation: "Station 10",
    jobsRedone: 2,
    timeInStation: "2h 33m",
    completionRate: 48,
    estCompletionDate: "2026-04-20",
    timeOnLine: "5d 0h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012073",
        status: "Completed",
        workers: "Trayveon Vasser, Antonio Viera",
        lastUpdated: "2026-04-15 07:45",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012074",
        status: "Completed",
        workers: "Andrew Volpetti",
        lastUpdated: "2026-04-15 11:30",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012075",
        status: "Completed",
        workers: "Marcus Walker, Samuel Watts",
        lastUpdated: "2026-04-15 15:15",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012076",
        status: "Completed",
        workers: "Gavin Wentworth",
        lastUpdated: "2026-04-16 09:20",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012077",
        status: "Completed",
        workers: "Austin Weston, Kaleb Williams",
        lastUpdated: "2026-04-16 13:45",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012078",
        status: "Completed",
        workers: "Richard Williams",
        lastUpdated: "2026-04-17 10:30",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012079",
        status: "Completed",
        workers: "Andrew Wise, Alexis Wolbert",
        lastUpdated: "2026-04-17 15:20",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012080",
        status: "Completed",
        workers: "Joel Worley",
        lastUpdated: "2026-04-18 10:45",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012081",
        status: "Completed",
        workers: "Francisco Zainos, Jesus Aguilar Parra",
        lastUpdated: "2026-04-18 15:35",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012082",
        status: "In Progress",
        workers: "Keith Alves, Erick U Armenta",
        lastUpdated: "2026-04-19 13:42",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012083",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012084",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 326 - PROTO",
    onlineDate: "2026-04-17",
    workOrder: "12WO001009",
    itemNumber: "P42-PL1-TG.2-309",
    batchNumber: "CDLRZ32603217E002",
    sqft: 552,
    currentStation: "Station 7",
    jobsRedone: 1,
    timeInStation: "3h 44m",
    completionRate: 33,
    estCompletionDate: "2026-04-23",
    timeOnLine: "3d 12h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012085",
        status: "Completed",
        workers: "Ramon Armenta, America D Arriaga",
        lastUpdated: "2026-04-17 08:00",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012086",
        status: "Completed",
        workers: "Shaundale Arthur",
        lastUpdated: "2026-04-17 11:20",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012087",
        status: "Completed",
        workers: "Jeremiah Bagby, Robbie Bauder",
        lastUpdated: "2026-04-17 14:55",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012088",
        status: "Completed",
        workers: "Dale Berridge",
        lastUpdated: "2026-04-18 09:30",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012089",
        status: "Completed",
        workers: "Greg Brent, Zach Buckner",
        lastUpdated: "2026-04-18 13:15",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012090",
        status: "Completed",
        workers: "James Cains",
        lastUpdated: "2026-04-19 10:40",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012091",
        status: "In Progress",
        workers: "Gloria Calleros, Weston Calta",
        lastUpdated: "2026-04-19 15:27",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012092",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 326 - PROTO",
    onlineDate: "2026-04-16",
    workOrder: "12WO001010",
    itemNumber: "P42-PL2-T-114",
    batchNumber: "CDLRZ00205107002",
    sqft: 507,
    currentStation: "Station 14",
    jobsRedone: 4,
    timeInStation: "2h 30m",
    completionRate: 68,
    estCompletionDate: "2026-04-19",
    timeOnLine: "7d 0h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012093",
        status: "Completed",
        workers: "Joseph Campillo, Maria Carmona",
        lastUpdated: "2026-04-16 07:30",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012094",
        status: "Completed",
        workers: "Clara Castillo",
        lastUpdated: "2026-04-16 10:50",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012095",
        status: "Completed",
        workers: "Jesse Cobb, Kevin Cottle",
        lastUpdated: "2026-04-16 14:35",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012096",
        status: "Completed",
        workers: "Thomas Cox",
        lastUpdated: "2026-04-17 08:40",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012097",
        status: "Completed",
        workers: "Clayton Cridlebaugh, Carsten Curtis",
        lastUpdated: "2026-04-17 12:25",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012098",
        status: "Completed",
        workers: "Ryan Decou",
        lastUpdated: "2026-04-18 09:15",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012099",
        status: "Completed",
        workers: "Katelyn Draper, Joshua Eid",
        lastUpdated: "2026-04-18 14:50",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012100",
        status: "Completed",
        workers: "Dominic Festa",
        lastUpdated: "2026-04-19 10:25",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012101",
        status: "Completed",
        workers: "Ricardo Fonseca, Herbert Gamble",
        lastUpdated: "2026-04-19 15:40",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012102",
        status: "Completed",
        workers: "Kesha Garcia",
        lastUpdated: "2026-04-20 09:35",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012103",
        status: "Completed",
        workers: "Savannah Gass, Brok Glazewski",
        lastUpdated: "2026-04-20 14:20",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012104",
        status: "Completed",
        workers: "Jose Gonzalez",
        lastUpdated: "2026-04-21 10:15",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012105",
        status: "Completed",
        workers: "Joseph Goritski, Alonzo Groves",
        lastUpdated: "2026-04-21 15:50",
      },
      {
        jobName: "Bulkhead/Drop Ceiling Install",
        jobId: "JOB000012106",
        status: "In Progress",
        workers: "Daymeon Guy, Zyain Guy",
        lastUpdated: "2026-04-22 13:33",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012107",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 6",
    onlineDate: "2026-04-15",
    workOrder: "12WO001011",
    itemNumber: "P42-PL2-T-214",
    batchNumber: "CDLRZ00205207002",
    sqft: 810,
    currentStation: "Station 20",
    jobsRedone: 4,
    timeInStation: "2h 8m",
    completionRate: 98,
    estCompletionDate: "2026-04-15",
    timeOnLine: "10d 0h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012108",
        status: "Completed",
        workers: "Philip Heredia, Brandon Hernandez",
        lastUpdated: "2026-04-15 07:15",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012109",
        status: "Completed",
        workers: "Marian Hernandez",
        lastUpdated: "2026-04-15 10:40",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012110",
        status: "Completed",
        workers: "Uipa Ili, Ulano Jones",
        lastUpdated: "2026-04-15 14:25",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012111",
        status: "Completed",
        workers: "Michael Lancaster",
        lastUpdated: "2026-04-16 08:50",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012112",
        status: "Completed",
        workers: "Tania Leyva, Armond Littleton",
        lastUpdated: "2026-04-16 13:15",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012113",
        status: "Completed",
        workers: "Jerome McLaughlin",
        lastUpdated: "2026-04-17 09:40",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012114",
        status: "Completed",
        workers: "Ruth Melendez, Michael Miller",
        lastUpdated: "2026-04-17 14:30",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012115",
        status: "Completed",
        workers: "Alfredo Molina Varela",
        lastUpdated: "2026-04-18 10:20",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012116",
        status: "Completed",
        workers: "Tania Moreira, Braden Munday",
        lastUpdated: "2026-04-18 15:45",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012117",
        status: "Completed",
        workers: "Aldo Murrieta",
        lastUpdated: "2026-04-19 09:30",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012118",
        status: "Completed",
        workers: "Daniel Osuna, Thomas Perez",
        lastUpdated: "2026-04-19 14:15",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012119",
        status: "Completed",
        workers: "Lowell Plandes",
        lastUpdated: "2026-04-20 10:50",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012120",
        status: "Completed",
        workers: "Donald Puterbaugh, Joel Reyes Rios",
        lastUpdated: "2026-04-20 15:35",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012121",
        status: "Completed",
        workers: "Michael Roof",
        lastUpdated: "2026-04-21 09:25",
      },
      {
        jobName: "Bulkhead/Drop Ceiling Install",
        jobId: "JOB000012122",
        status: "Completed",
        workers: "Thomas Sanchez, Clint Shullaw",
        lastUpdated: "2026-04-21 14:40",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012123",
        status: "Completed",
        workers: "Demarien Smith",
        lastUpdated: "2026-04-22 10:15",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012124",
        status: "Completed",
        workers: "Frederick Straun, Everardo Suarez",
        lastUpdated: "2026-04-22 15:20",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012125",
        status: "Completed",
        workers: "Trayveon Vasser",
        lastUpdated: "2026-04-23 09:45",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012126",
        status: "Completed",
        workers: "Andrew Volpetti, Gavin Wentworth",
        lastUpdated: "2026-04-23 14:30",
      },
      {
        jobName: "Gypsum and Install",
        jobId: "JOB000012127",
        status: "Completed",
        workers: "Kaleb Williams",
        lastUpdated: "2026-04-24 10:55",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012128",
        status: "Completed",
        workers: "Andrew Wise, Taylen Woody",
        lastUpdated: "2026-04-24 15:40",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012129",
        status: "In Progress",
        workers: "Sheila Brown, Francisco Zainos",
        lastUpdated: "2026-04-25 11:52",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012130",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-17",
    workOrder: "12WO001012",
    itemNumber: "P42-PL2-TC-314",
    batchNumber: "CDLRZ00205307002",
    sqft: 552,
    currentStation: "Station 6",
    jobsRedone: 2,
    timeInStation: "3h 17m",
    completionRate: 28,
    estCompletionDate: "2026-04-24",
    timeOnLine: "3d 0h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012131",
        status: "Completed",
        workers: "Jesus Aguilar Parra, Ramon Armenta",
        lastUpdated: "2026-04-17 08:20",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012132",
        status: "Completed",
        workers: "Edgar Atienzo",
        lastUpdated: "2026-04-17 11:55",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012133",
        status: "Completed",
        workers: "Jeremiah Bagby, Salvador Belmudes",
        lastUpdated: "2026-04-17 15:30",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012134",
        status: "Completed",
        workers: "Greg Brent",
        lastUpdated: "2026-04-18 09:45",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012135",
        status: "Completed",
        workers: "Zach Buckner, Gloria Calleros",
        lastUpdated: "2026-04-18 13:20",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012136",
        status: "In Progress",
        workers: "Isaac Campillo, Maria Carmona",
        lastUpdated: "2026-04-19 14:38",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012137",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 326 - PROTO",
    onlineDate: "2026-04-16",
    workOrder: "12WO001013",
    itemNumber: "P42-PB4-WA-101",
    batchNumber: "CDLRZ00205113&14002",
    sqft: 507,
    currentStation: "Station 11",
    jobsRedone: 3,
    timeInStation: "2h 52m",
    completionRate: 54,
    estCompletionDate: "2026-04-20",
    timeOnLine: "5d 12h",
    activityHistory: [
      {
        jobName: "Saw HSS Steel Cutting Wall",
        jobId: "JOB000012138",
        status: "Completed",
        workers: "Kevin Castillo, Jesse Cobb",
        lastUpdated: "2026-04-16 07:50",
      },
      {
        jobName: "Saw HSS Ceiling/Base",
        jobId: "JOB000012139",
        status: "Completed",
        workers: "Thomas Cox",
        lastUpdated: "2026-04-16 11:25",
      },
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012140",
        status: "Completed",
        workers: "Joshua Dawson, Ryan Decou",
        lastUpdated: "2026-04-16 14:50",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012141",
        status: "Completed",
        workers: "Katelyn Draper",
        lastUpdated: "2026-04-17 08:35",
      },
      {
        jobName: "CNC Decking",
        jobId: "JOB000012142",
        status: "Completed",
        workers: "Antonio Edwards, Nathan Esper",
        lastUpdated: "2026-04-17 12:50",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012143",
        status: "Completed",
        workers: "Jesus Felix",
        lastUpdated: "2026-04-18 09:40",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000012144",
        status: "Completed",
        workers: "Richard Fernandez, Dominic Festa",
        lastUpdated: "2026-04-18 14:25",
      },
      {
        jobName: "Cabinet Build",
        jobId: "JOB000012145",
        status: "Completed",
        workers: "Shane Fry",
        lastUpdated: "2026-04-19 10:15",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012146",
        status: "Completed",
        workers: "Herbert Gamble, Christian Garay",
        lastUpdated: "2026-04-19 15:30",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012147",
        status: "Completed",
        workers: "Anthony Garcia",
        lastUpdated: "2026-04-20 09:50",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012148",
        status: "In Progress",
        workers: "Kesha Garcia, Myriah Gass",
        lastUpdated: "2026-04-21 12:15",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012149",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012150",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-17",
    workOrder: "12WO001014",
    itemNumber: "P42-PB1-MR-116",
    batchNumber: "CDLRZ00207109&10002",
    sqft: 810,
    currentStation: "Station 19",
    jobsRedone: 2,
    timeInStation: "2h 34m",
    completionRate: 93,
    estCompletionDate: "2026-05-01",
    timeOnLine: "9d 12h",
    activityHistory: [
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012151",
        status: "Completed",
        workers: "JuanPablo Alarcon, Andrew Amado",
        lastUpdated: "2026-04-17 08:15",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012152",
        status: "Completed",
        workers: "Andres Arrieta",
        lastUpdated: "2026-04-17 11:30",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012153",
        status: "Completed",
        workers: "Robbie Bauder, Tristan Brant",
        lastUpdated: "2026-04-17 15:00",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012154",
        status: "Completed",
        workers: "Brandon Brock",
        lastUpdated: "2026-04-18 08:15",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012155",
        status: "Completed",
        workers: "Zach Buckner, James Cains",
        lastUpdated: "2026-04-18 11:30",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012156",
        status: "Completed",
        workers: "Weston Calta",
        lastUpdated: "2026-04-18 15:00",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012157",
        status: "Completed",
        workers: "Joseph Campillo, Clara Castillo",
        lastUpdated: "2026-04-19 08:15",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012158",
        status: "Completed",
        workers: "Kevin Cottle",
        lastUpdated: "2026-04-19 11:30",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012159",
        status: "Completed",
        workers: "Clayton Cridlebaugh, Ryan Decou",
        lastUpdated: "2026-04-19 15:00",
      },
      {
        jobName: "Bulkhead/Drop Ceiling  Install",
        jobId: "JOB000012160",
        status: "Completed",
        workers: "Angel Farias",
        lastUpdated: "2026-04-20 08:15",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012161",
        status: "Completed",
        workers: "Dominic Festa, Ricardo Fonseca",
        lastUpdated: "2026-04-20 11:30",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012162",
        status: "Completed",
        workers: "Shane Fry",
        lastUpdated: "2026-04-20 15:00",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012163",
        status: "Completed",
        workers: "Christian Garay, Alexis Garcia",
        lastUpdated: "2026-04-21 08:15",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012164",
        status: "Completed",
        workers: "Brok Glazewski",
        lastUpdated: "2026-04-21 11:30",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000012165",
        status: "Completed",
        workers: "Christopher Grant, Jonathan Gressel",
        lastUpdated: "2026-04-21 15:00",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012166",
        status: "Completed",
        workers: "Javier Guerrero",
        lastUpdated: "2026-04-22 08:15",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012167",
        status: "Completed",
        workers: "Adeline Gutierrez, Zachary Hall",
        lastUpdated: "2026-04-22 11:30",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012168",
        status: "Completed",
        workers: "Keith Henderson",
        lastUpdated: "2026-04-22 15:00",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000012169",
        status: "Completed",
        workers: "Zach Herbstreith, Daniel Holland",
        lastUpdated: "2026-04-23 08:15",
      },
      {
        jobName: "Fire Caulking",
        jobId: "JOB000012170",
        status: "Completed",
        workers: "Hanna Jackson",
        lastUpdated: "2026-04-23 11:30",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000012171",
        status: "Completed",
        workers: "Ulano Jones, Virgil Klade",
        lastUpdated: "2026-04-23 15:00",
      },
      {
        jobName: "Finished Exterior",
        jobId: "JOB000012172",
        status: "Completed",
        workers: "Michael Lancaster",
        lastUpdated: "2026-04-24 08:15",
      },
      {
        jobName: "Window and Door Installation",
        jobId: "JOB000012173",
        status: "Completed",
        workers: "Jorge Leon Arvizu, Pablo Leon",
        lastUpdated: "2026-04-24 11:30",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000012174",
        status: "Completed",
        workers: "Armond Littleton",
        lastUpdated: "2026-04-24 15:00",
      },
      {
        jobName: "Roofing",
        jobId: "JOB000012175",
        status: "Completed",
        workers: "Jesse Marquez, Rosalio Marquez",
        lastUpdated: "2026-04-25 08:15",
      },
      {
        jobName: "Prime and Paint",
        jobId: "JOB000012176",
        status: "Completed",
        workers: "Gene Marsh",
        lastUpdated: "2026-04-25 11:30",
      },
      {
        jobName: "Cabinets/Vanities/Countertops Install",
        jobId: "JOB000012177",
        status: "Completed",
        workers: "Devon Menjivar, Michael Miller",
        lastUpdated: "2026-04-25 15:00",
      },
      {
        jobName: "Final HVAC",
        jobId: "JOB000012178",
        status: "Completed",
        workers: "Scott Morrison",
        lastUpdated: "2026-04-26 08:15",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000012179",
        status: "Completed",
        workers: "Dylan Munoz, Travis Nez",
        lastUpdated: "2026-04-26 11:30",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000012180",
        status: "Completed",
        workers: "Jesus Orona",
        lastUpdated: "2026-04-26 15:00",
      },
      {
        jobName: "Final Finish, Appliance Install",
        jobId: "JOB000012181",
        status: "Completed",
        workers: "Charles Parker, Thomas Perez",
        lastUpdated: "2026-04-27 08:15",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000012182",
        status: "Completed",
        workers: "Alexander Perry",
        lastUpdated: "2026-04-27 11:30",
      },
      {
        jobName: "Final Inspection",
        jobId: "JOB000012183",
        status: "In Progress",
        workers: "Leighton Pittmann, Steve Poniewierski",
        lastUpdated: "2026-04-27 16:00",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000012184",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Close up and Shrink Wrap",
        jobId: "JOB000012185",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 6",
    onlineDate: "2026-04-17",
    workOrder: "12WO001015",
    itemNumber: "P42-PB1-MR-216",
    batchNumber: "CDLRZ00207209&10002",
    sqft: 552,
    currentStation: "Station 17",
    jobsRedone: 3,
    timeInStation: "3h 12m",
    completionRate: 83,
    estCompletionDate: "2026-04-30",
    timeOnLine: "8d 12h",
    activityHistory: [
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012186",
        status: "Completed",
        workers: "Frank Reyes, Rowan Ripley",
        lastUpdated: "2026-04-17 08:00",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012187",
        status: "Completed",
        workers: "Thomas Rodriguez",
        lastUpdated: "2026-04-17 11:45",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012188",
        status: "Completed",
        workers: "Adrian Roque, Jose Saenz",
        lastUpdated: "2026-04-17 15:15",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012189",
        status: "Completed",
        workers: "Gabriel Sandoval",
        lastUpdated: "2026-04-18 08:00",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012190",
        status: "Completed",
        workers: "Carter Snell, Isaac Soliz",
        lastUpdated: "2026-04-18 11:45",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012191",
        status: "Completed",
        workers: "Bunna Som",
        lastUpdated: "2026-04-18 15:15",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012192",
        status: "Completed",
        workers: "Frederick Straun, Everardo Suarez",
        lastUpdated: "2026-04-19 08:00",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012193",
        status: "Completed",
        workers: "Michael Taylor",
        lastUpdated: "2026-04-19 11:45",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012194",
        status: "Completed",
        workers: "Dominick Teller, Cristofer Valencia",
        lastUpdated: "2026-04-19 15:15",
      },
      {
        jobName: "Bulkhead/Drop Ceiling  Install",
        jobId: "JOB000012195",
        status: "Completed",
        workers: "Cortez Valenzuela",
        lastUpdated: "2026-04-20 08:00",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012196",
        status: "Completed",
        workers: "Gabriel Valles, Trayveon Vasser",
        lastUpdated: "2026-04-20 11:45",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012197",
        status: "Completed",
        workers: "Marcus Walker",
        lastUpdated: "2026-04-20 15:15",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012198",
        status: "Completed",
        workers: "Samuel Watts, Austin Weston",
        lastUpdated: "2026-04-21 08:00",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012199",
        status: "Completed",
        workers: "Richard Williams",
        lastUpdated: "2026-04-21 11:45",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000012200",
        status: "Completed",
        workers: "Joel Worley, Malachi Derichsweiler",
        lastUpdated: "2026-04-21 15:15",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012201",
        status: "Completed",
        workers: "Rosselis Borges",
        lastUpdated: "2026-04-22 08:00",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012202",
        status: "Completed",
        workers: "Samuel Godinez, Eduardo Siordia",
        lastUpdated: "2026-04-22 11:45",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012203",
        status: "Completed",
        workers: "Jackson Nielson",
        lastUpdated: "2026-04-22 15:15",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000012204",
        status: "Completed",
        workers: "Destiny Perez, Denali Garay",
        lastUpdated: "2026-04-23 08:00",
      },
      {
        jobName: "Fire Caulking",
        jobId: "JOB000012205",
        status: "Completed",
        workers: "Stephen Goldberg",
        lastUpdated: "2026-04-23 11:45",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000012206",
        status: "Completed",
        workers: "Armando Gomez, Justin Francis",
        lastUpdated: "2026-04-23 15:15",
      },
      {
        jobName: "Finished Exterior",
        jobId: "JOB000012207",
        status: "Completed",
        workers: "Hailey Spence",
        lastUpdated: "2026-04-24 08:00",
      },
      {
        jobName: "Window and Door Installation",
        jobId: "JOB000012208",
        status: "Completed",
        workers: "Sophie Young, Justin Littlewhirlwind",
        lastUpdated: "2026-04-24 11:45",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000012209",
        status: "Completed",
        workers: "JuanPablo Alarcon",
        lastUpdated: "2026-04-24 15:15",
      },
      {
        jobName: "Roofing",
        jobId: "JOB000012210",
        status: "Completed",
        workers: "Andrew Amado, Andres Arrieta",
        lastUpdated: "2026-04-25 08:00",
      },
      {
        jobName: "Prime and Paint",
        jobId: "JOB000012211",
        status: "Completed",
        workers: "Shaundale Arthur",
        lastUpdated: "2026-04-25 11:45",
      },
      {
        jobName: "Cabinets/Vanities/Countertops Install",
        jobId: "JOB000012212",
        status: "Completed",
        workers: "Robbie Bauder, Tristan Brant",
        lastUpdated: "2026-04-25 15:15",
      },
      {
        jobName: "Final HVAC",
        jobId: "JOB000012213",
        status: "Completed",
        workers: "Greg Brent",
        lastUpdated: "2026-04-26 08:00",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000012214",
        status: "Completed",
        workers: "Brandon Brock, Zach Buckner",
        lastUpdated: "2026-04-26 11:45",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000012215",
        status: "In Progress",
        workers: "James Cains, Weston Calta",
        lastUpdated: "2026-04-26 16:15",
      },
      {
        jobName: "Final Finish, Appliance Install",
        jobId: "JOB000012216",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000012217",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Inspection",
        jobId: "JOB000012218",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000012219",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Close up and Shrink Wrap",
        jobId: "JOB000012220",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-18",
    workOrder: "12WO001016",
    itemNumber: "P42-PB1-MRC-316",
    batchNumber: "CDLRZ00207309&10002",
    sqft: 810,
    currentStation: "Station 15",
    jobsRedone: 1,
    timeInStation: "2h 18m",
    completionRate: 73,
    estCompletionDate: "2026-05-01",
    timeOnLine: "7d 12h",
    activityHistory: [
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012221",
        status: "Completed",
        workers: "Antonio Edwards",
        lastUpdated: "2026-04-18 08:20",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012222",
        status: "Completed",
        workers: "Josef Eid, Nathan Esper",
        lastUpdated: "2026-04-18 11:45",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012223",
        status: "Completed",
        workers: "Angel Farias",
        lastUpdated: "2026-04-18 15:10",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012224",
        status: "Completed",
        workers: "Jesus Felix, Dominic Festa",
        lastUpdated: "2026-04-19 08:20",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012225",
        status: "Completed",
        workers: "Ricardo Fonseca",
        lastUpdated: "2026-04-19 11:45",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012226",
        status: "Completed",
        workers: "Shane Fry, Christian Garay",
        lastUpdated: "2026-04-19 15:10",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012227",
        status: "Completed",
        workers: "Alexis Garcia",
        lastUpdated: "2026-04-20 08:20",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012228",
        status: "Completed",
        workers: "Anthony Garcia, Kesha Garcia",
        lastUpdated: "2026-04-20 11:45",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012229",
        status: "Completed",
        workers: "Myriah Gass",
        lastUpdated: "2026-04-20 15:10",
      },
      {
        jobName: "Bulkhead/Drop Ceiling  Install",
        jobId: "JOB000012230",
        status: "Completed",
        workers: "Savannah Gass, Brok Glazewski",
        lastUpdated: "2026-04-21 08:20",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012231",
        status: "Completed",
        workers: "Juan Godinez",
        lastUpdated: "2026-04-21 11:45",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012232",
        status: "Completed",
        workers: "Jose Gonzalez, Luis Gonzalez",
        lastUpdated: "2026-04-21 15:10",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012233",
        status: "Completed",
        workers: "Jeremy Goritski",
        lastUpdated: "2026-04-22 08:20",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012234",
        status: "Completed",
        workers: "Christopher Grant, Jonathan Gressel",
        lastUpdated: "2026-04-22 11:45",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000012235",
        status: "Completed",
        workers: "Javier Guerrero, Dominic Guevara",
        lastUpdated: "2026-04-22 15:10",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012236",
        status: "Completed",
        workers: "Adeline Gutierrez",
        lastUpdated: "2026-04-23 08:20",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012237",
        status: "Completed",
        workers: "Nestor Gutierrez, Daymeon Guy",
        lastUpdated: "2026-04-23 11:45",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012238",
        status: "Completed",
        workers: "Zachary Hall",
        lastUpdated: "2026-04-23 15:10",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000012239",
        status: "Completed",
        workers: "Keith Henderson, Zach Herbstreith",
        lastUpdated: "2026-04-24 08:20",
      },
      {
        jobName: "Fire Caulking",
        jobId: "JOB000012240",
        status: "Completed",
        workers: "Joe Hernandes",
        lastUpdated: "2026-04-24 11:45",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000012241",
        status: "Completed",
        workers: "Adrian Hernandez, Alfredo Hernandez",
        lastUpdated: "2026-04-24 15:10",
      },
      {
        jobName: "Finished Exterior",
        jobId: "JOB000012242",
        status: "Completed",
        workers: "Fred Levins",
        lastUpdated: "2026-04-25 08:20",
      },
      {
        jobName: "Window and Door Installation",
        jobId: "JOB000012243",
        status: "Completed",
        workers: "Jose Holguin, Daniel Holland",
        lastUpdated: "2026-04-25 11:45",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000012244",
        status: "Completed",
        workers: "Uipa Ili, Hanna Jackson",
        lastUpdated: "2026-04-25 15:10",
      },
      {
        jobName: "Roofing",
        jobId: "JOB000012245",
        status: "Completed",
        workers: "Ulano Jones",
        lastUpdated: "2026-04-26 08:20",
      },
      {
        jobName: "Prime and Paint",
        jobId: "JOB000012246",
        status: "In Progress",
        workers: "Virgil Klade, Michael Lancaster",
        lastUpdated: "2026-04-26 13:45",
      },
      {
        jobName: "Cabinets/Vanities/Countertops Install",
        jobId: "JOB000012247",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final HVAC",
        jobId: "JOB000012248",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000012249",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000012250",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Finish, Appliance Install",
        jobId: "JOB000012251",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000012252",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Inspection",
        jobId: "JOB000012253",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000012254",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Close up and Shrink Wrap",
        jobId: "JOB000012255",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 6",
    onlineDate: "2026-04-19",
    workOrder: "12WO001017",
    itemNumber: "P42-PB4-WA-101",
    batchNumber: "CDLRZ00207102&01001",
    sqft: 552,
    currentStation: "Station 13",
    jobsRedone: 2,
    timeInStation: "2h 47m",
    completionRate: 63,
    estCompletionDate: "2026-05-01",
    timeOnLine: "6d 12h",
    activityHistory: [
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012256",
        status: "Completed",
        workers: "Frank Reyes, Rowan Ripley",
        lastUpdated: "2026-04-19 08:00",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012257",
        status: "Completed",
        workers: "Thomas Rodriguez",
        lastUpdated: "2026-04-19 11:15",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012258",
        status: "Completed",
        workers: "Adrian Roque, Jose Saenz",
        lastUpdated: "2026-04-19 15:45",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012259",
        status: "Completed",
        workers: "Gabriel Sandoval",
        lastUpdated: "2026-04-20 08:00",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012260",
        status: "Completed",
        workers: "Carter Snell, Isaac Soliz",
        lastUpdated: "2026-04-20 11:15",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012261",
        status: "Completed",
        workers: "Bunna Som",
        lastUpdated: "2026-04-20 15:45",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012262",
        status: "Completed",
        workers: "Frederick Straun, Everardo Suarez",
        lastUpdated: "2026-04-21 08:00",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012263",
        status: "Completed",
        workers: "Michael Taylor",
        lastUpdated: "2026-04-21 11:15",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012264",
        status: "Completed",
        workers: "Dominick Teller, Cristofer Valencia",
        lastUpdated: "2026-04-21 15:45",
      },
      {
        jobName: "Bulkhead/Drop Ceiling  Install",
        jobId: "JOB000012265",
        status: "Completed",
        workers: "Cortez Valenzuela",
        lastUpdated: "2026-04-22 08:00",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012266",
        status: "Completed",
        workers: "Gabriel Valles, Trayveon Vasser",
        lastUpdated: "2026-04-22 11:15",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012267",
        status: "Completed",
        workers: "Marcus Walker",
        lastUpdated: "2026-04-22 15:45",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012268",
        status: "Completed",
        workers: "Samuel Watts, Austin Weston",
        lastUpdated: "2026-04-23 08:00",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012269",
        status: "Completed",
        workers: "Richard Williams",
        lastUpdated: "2026-04-23 11:15",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000012270",
        status: "Completed",
        workers: "Joel Worley, Malachi Derichsweiler",
        lastUpdated: "2026-04-23 15:45",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012271",
        status: "Completed",
        workers: "Rosselis Borges",
        lastUpdated: "2026-04-24 08:00",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012272",
        status: "Completed",
        workers: "Samuel Godinez, Eduardo Siordia",
        lastUpdated: "2026-04-24 11:15",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012273",
        status: "Completed",
        workers: "Jackson Nielson",
        lastUpdated: "2026-04-24 15:45",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000012274",
        status: "Completed",
        workers: "Destiny Perez, Denali Garay",
        lastUpdated: "2026-04-25 08:00",
      },
      {
        jobName: "Fire Caulking",
        jobId: "JOB000012275",
        status: "Completed",
        workers: "Stephen Goldberg",
        lastUpdated: "2026-04-25 11:15",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000012276",
        status: "Completed",
        workers: "Armando Gomez, Justin Francis",
        lastUpdated: "2026-04-25 15:45",
      },
      {
        jobName: "Finished Exterior",
        jobId: "JOB000012277",
        status: "Completed",
        workers: "Hailey Spence",
        lastUpdated: "2026-04-26 08:00",
      },
      {
        jobName: "Window and Door Installation",
        jobId: "JOB000012278",
        status: "Paused",
        workers: "Sophie Young, Justin Littlewhirlwind",
        lastUpdated: "2026-04-26 13:15",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000012279",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Roofing",
        jobId: "JOB000012280",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Prime and Paint",
        jobId: "JOB000012281",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Cabinets/Vanities/Countertops Install",
        jobId: "JOB000012282",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final HVAC",
        jobId: "JOB000012283",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000012284",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000012285",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Finish, Appliance Install",
        jobId: "JOB000012286",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000012287",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Inspection",
        jobId: "JOB000012288",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000012289",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Close up and Shrink Wrap",
        jobId: "JOB000012290",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-19",
    workOrder: "12WO001018",
    itemNumber: "P42-PB4-WR-201",
    batchNumber: "CDLRZ00207202&01001",
    sqft: 810,
    currentStation: "Station 11",
    jobsRedone: 1,
    timeInStation: "3h 05m",
    completionRate: 53,
    estCompletionDate: "2026-05-02",
    timeOnLine: "5d 12h",
    activityHistory: [
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012291",
        status: "Completed",
        workers: "Antonio Edwards",
        lastUpdated: "2026-04-19 08:50",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012292",
        status: "Completed",
        workers: "Josef Eid, Nathan Esper",
        lastUpdated: "2026-04-19 11:05",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012293",
        status: "Completed",
        workers: "Angel Farias",
        lastUpdated: "2026-04-19 15:35",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012294",
        status: "Completed",
        workers: "Jesus Felix, Dominic Festa",
        lastUpdated: "2026-04-20 08:50",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012295",
        status: "Completed",
        workers: "Ricardo Fonseca",
        lastUpdated: "2026-04-20 11:05",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012296",
        status: "Completed",
        workers: "Shane Fry, Christian Garay",
        lastUpdated: "2026-04-20 15:35",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012297",
        status: "Completed",
        workers: "Alexis Garcia",
        lastUpdated: "2026-04-21 08:50",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012298",
        status: "Completed",
        workers: "Anthony Garcia, Kesha Garcia",
        lastUpdated: "2026-04-21 11:05",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012299",
        status: "Completed",
        workers: "Myriah Gass",
        lastUpdated: "2026-04-21 15:35",
      },
      {
        jobName: "Bulkhead/Drop Ceiling  Install",
        jobId: "JOB000012300",
        status: "Completed",
        workers: "Savannah Gass, Brok Glazewski",
        lastUpdated: "2026-04-22 08:50",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012301",
        status: "Completed",
        workers: "Juan Godinez",
        lastUpdated: "2026-04-22 11:05",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012302",
        status: "Completed",
        workers: "Jose Gonzalez, Luis Gonzalez",
        lastUpdated: "2026-04-22 15:35",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012303",
        status: "Completed",
        workers: "Jeremy Goritski",
        lastUpdated: "2026-04-23 08:50",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012304",
        status: "Completed",
        workers: "Christopher Grant, Jonathan Gressel",
        lastUpdated: "2026-04-23 11:05",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000012305",
        status: "Completed",
        workers: "Javier Guerrero, Dominic Guevara",
        lastUpdated: "2026-04-23 15:35",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012306",
        status: "Completed",
        workers: "Adeline Gutierrez",
        lastUpdated: "2026-04-24 08:50",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012307",
        status: "Completed",
        workers: "Nestor Gutierrez, Daymeon Guy",
        lastUpdated: "2026-04-24 11:05",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012308",
        status: "Completed",
        workers: "Zachary Hall",
        lastUpdated: "2026-04-24 15:35",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000012309",
        status: "In Progress",
        workers: "Keith Henderson, Zach Herbstreith",
        lastUpdated: "2026-04-25 09:50",
      },
      {
        jobName: "Fire Caulking",
        jobId: "JOB000012310",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000012311",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Finished Exterior",
        jobId: "JOB000012312",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Window and Door Installation",
        jobId: "JOB000012313",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000012314",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Roofing",
        jobId: "JOB000012315",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Prime and Paint",
        jobId: "JOB000012316",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Cabinets/Vanities/Countertops Install",
        jobId: "JOB000012317",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final HVAC",
        jobId: "JOB000012318",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000012319",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000012320",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Finish, Appliance Install",
        jobId: "JOB000012321",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000012322",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Inspection",
        jobId: "JOB000012323",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000012324",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Close up and Shrink Wrap",
        jobId: "JOB000012325",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 6",
    onlineDate: "2026-04-20",
    workOrder: "12WO001019",
    itemNumber: "P42-PB4-WRC-301",
    batchNumber: "CDLRZ00207302&01001",
    sqft: 552,
    currentStation: "Station 9",
    jobsRedone: 3,
    timeInStation: "2h 22m",
    completionRate: 43,
    estCompletionDate: "2026-05-02",
    timeOnLine: "4d 12h",
    activityHistory: [
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012326",
        status: "Completed",
        workers: "JuanPablo Alarcon, Andrew Amado",
        lastUpdated: "2026-04-20 08:10",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012327",
        status: "Completed",
        workers: "Andres Arrieta",
        lastUpdated: "2026-04-20 11:30",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012328",
        status: "Completed",
        workers: "Robbie Bauder, Tristan Brant",
        lastUpdated: "2026-04-20 15:00",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012329",
        status: "Completed",
        workers: "Brandon Brock",
        lastUpdated: "2026-04-21 08:10",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012330",
        status: "Completed",
        workers: "Zach Buckner, James Cains",
        lastUpdated: "2026-04-21 11:30",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012331",
        status: "Completed",
        workers: "Weston Calta",
        lastUpdated: "2026-04-21 15:00",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012332",
        status: "Completed",
        workers: "Joseph Campillo, Clara Castillo",
        lastUpdated: "2026-04-22 08:10",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012333",
        status: "Completed",
        workers: "Kevin Cottle",
        lastUpdated: "2026-04-22 11:30",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012334",
        status: "Completed",
        workers: "Clayton Cridlebaugh, Ryan Decou",
        lastUpdated: "2026-04-22 15:00",
      },
      {
        jobName: "Bulkhead/Drop Ceiling  Install",
        jobId: "JOB000012335",
        status: "Completed",
        workers: "Angel Farias",
        lastUpdated: "2026-04-23 08:10",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012336",
        status: "Completed",
        workers: "Dominic Festa, Ricardo Fonseca",
        lastUpdated: "2026-04-23 11:30",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012337",
        status: "Completed",
        workers: "Shane Fry",
        lastUpdated: "2026-04-23 15:00",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012338",
        status: "Completed",
        workers: "Christian Garay, Alexis Garcia",
        lastUpdated: "2026-04-24 08:10",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012339",
        status: "Completed",
        workers: "Brok Glazewski",
        lastUpdated: "2026-04-24 11:30",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000012340",
        status: "Completed",
        workers: "Christopher Grant, Jonathan Gressel",
        lastUpdated: "2026-04-24 15:00",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012341",
        status: "In Progress",
        workers: "Javier Guerrero",
        lastUpdated: "2026-04-25 09:10",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012342",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012343",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000012344",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Caulking",
        jobId: "JOB000012345",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000012346",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Finished Exterior",
        jobId: "JOB000012347",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Window and Door Installation",
        jobId: "JOB000012348",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000012349",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Roofing",
        jobId: "JOB000012350",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Prime and Paint",
        jobId: "JOB000012351",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Cabinets/Vanities/Countertops Install",
        jobId: "JOB000012352",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final HVAC",
        jobId: "JOB000012353",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000012354",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000012355",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Finish, Appliance Install",
        jobId: "JOB000012356",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000012357",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Inspection",
        jobId: "JOB000012358",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000012359",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Close up and Shrink Wrap",
        jobId: "JOB000012360",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 5",
    onlineDate: "2026-04-21",
    workOrder: "12WO001020",
    itemNumber: "P42-PL1A-T.3-103",
    batchNumber: "CDLRZ00207102&01002",
    sqft: 810,
    currentStation: "Station 7",
    jobsRedone: 0,
    timeInStation: "2h 55m",
    completionRate: 33,
    estCompletionDate: "2026-05-02",
    timeOnLine: "3d 12h",
    activityHistory: [
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012361",
        status: "Completed",
        workers: "Devon Menjivar, Michael Miller",
        lastUpdated: "2026-04-21 08:05",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012362",
        status: "Completed",
        workers: "Arturo Morales",
        lastUpdated: "2026-04-21 11:30",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012363",
        status: "Completed",
        workers: "Tania Moreira, Scott Morrison",
        lastUpdated: "2026-04-21 15:55",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012364",
        status: "Completed",
        workers: "Braden Munday",
        lastUpdated: "2026-04-22 08:05",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012365",
        status: "Completed",
        workers: "Dylan Munoz, Oscar Murillo Garcia",
        lastUpdated: "2026-04-22 11:30",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012366",
        status: "Completed",
        workers: "Travis Nez",
        lastUpdated: "2026-04-22 15:55",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012367",
        status: "Completed",
        workers: "Steven Ontiveros, Seth Ornelas",
        lastUpdated: "2026-04-23 08:05",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012368",
        status: "Completed",
        workers: "Jesus Orona",
        lastUpdated: "2026-04-23 11:30",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012369",
        status: "Completed",
        workers: "Efren Ortiz, Martin Ortiz",
        lastUpdated: "2026-04-23 15:55",
      },
      {
        jobName: "Bulkhead/Drop Ceiling  Install",
        jobId: "JOB000012370",
        status: "Completed",
        workers: "Charles Parker",
        lastUpdated: "2026-04-24 08:05",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012371",
        status: "Completed",
        workers: "Thomas Perez, Dominic Perreault",
        lastUpdated: "2026-04-24 11:30",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012372",
        status: "In Progress",
        workers: "Alexander Perry",
        lastUpdated: "2026-04-24 16:55",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012373",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012374",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000012375",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012376",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012377",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012378",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000012379",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Caulking",
        jobId: "JOB000012380",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000012381",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Finished Exterior",
        jobId: "JOB000012382",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Window and Door Installation",
        jobId: "JOB000012383",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000012384",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Roofing",
        jobId: "JOB000012385",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Prime and Paint",
        jobId: "JOB000012386",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Cabinets/Vanities/Countertops Install",
        jobId: "JOB000012387",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final HVAC",
        jobId: "JOB000012388",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000012389",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000012390",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Finish, Appliance Install",
        jobId: "JOB000012391",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000012392",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Inspection",
        jobId: "JOB000012393",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000012394",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Close up and Shrink Wrap",
        jobId: "JOB000012395",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
  {
    property: "Flatz 480 - Building 6",
    onlineDate: "2026-04-23",
    workOrder: "12WO001021",
    itemNumber: "P42-PL1-T.3-203",
    batchNumber: "CDLRZ00207202&01002",
    sqft: 552,
    currentStation: "Station 4",
    jobsRedone: 1,
    timeInStation: "2h 43m",
    completionRate: 18,
    estCompletionDate: "2026-05-03",
    timeOnLine: "2d 0h",
    activityHistory: [
      {
        jobName: "Prefab/Kitting",
        jobId: "JOB000012396",
        status: "Completed",
        workers: "Frank Reyes, Rowan Ripley",
        lastUpdated: "2026-04-23 08:20",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000012397",
        status: "Completed",
        workers: "Thomas Rodriguez",
        lastUpdated: "2026-04-23 11:50",
      },
      {
        jobName: "Care Package Prep",
        jobId: "JOB000012398",
        status: "Completed",
        workers: "Adrian Roque, Jose Saenz",
        lastUpdated: "2026-04-23 15:25",
      },
      {
        jobName: "CNC Gypsum",
        jobId: "JOB000012399",
        status: "Completed",
        workers: "Gabriel Sandoval",
        lastUpdated: "2026-04-24 08:20",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000012400",
        status: "Completed",
        workers: "Carter Snell, Isaac Soliz",
        lastUpdated: "2026-04-24 11:50",
      },
      {
        jobName: "Ceiling Furring Channel Install",
        jobId: "JOB000012401",
        status: "Completed",
        workers: "Bunna Som",
        lastUpdated: "2026-04-24 15:25",
      },
      {
        jobName: "Roof/Ceiling Waterproofing",
        jobId: "JOB000012402",
        status: "In Progress",
        workers: "Frederick Straun, Everardo Suarez",
        lastUpdated: "2026-04-25 09:20",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000012403",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Interior Wall install",
        jobId: "JOB000012404",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Bulkhead/Drop Ceiling  Install",
        jobId: "JOB000012405",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000012406",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000012407",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000012408",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000012409",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000012410",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000012411",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Floor Underlayment Install",
        jobId: "JOB000012412",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Finish Flooring Install",
        jobId: "JOB000012413",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000012414",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Caulking",
        jobId: "JOB000012415",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000012416",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Finished Exterior",
        jobId: "JOB000012417",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Window and Door Installation",
        jobId: "JOB000012418",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000012419",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Roofing",
        jobId: "JOB000012420",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Prime and Paint",
        jobId: "JOB000012421",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Cabinets/Vanities/Countertops Install",
        jobId: "JOB000012422",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final HVAC",
        jobId: "JOB000012423",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000012424",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000012425",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Finish, Appliance Install",
        jobId: "JOB000012426",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000012427",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Final Inspection",
        jobId: "JOB000012428",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000012429",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
      {
        jobName: "Close up and Shrink Wrap",
        jobId: "JOB000012430",
        status: "Pending",
        workers: "—",
        lastUpdated: "—",
      },
    ],
  },
];

export default MOCK_MODULES;
